export default [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "event" */ '../participants/Index.vue'),
    meta: {
      roles: ['Admin', 'Master', 'Viewer']
    }
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import(/* webpackChunkName: "event" */ '../home/Unauthorized.vue'),
    meta: {
      roles: ['Admin', 'Master', 'Operator', 'Viewer']
    }
  }
]
